import { HttpErrorResponse } from '@angular/common/http';

import { createSelector } from '@ngrx/store';

import { BillingPlan } from '@recruitee/http/types';
import { createSingleEntityStore } from '@recruitee/ngrx';

export interface Store {
  activePlan: BillingPlan;
  billingPlans: BillingPlan[];
}

const { actions, selectors, namespace, reducer } = createSingleEntityStore<Store | null>()(
  'BillingPlans',
  {
    customActions: adapter => ({
      fetchSuccess: (state, payload) => adapter.update(state, { billingPlans: payload.plans }),
      fetchActivePlan: state => adapter.markAsPending(state),
      fetchActivePlanSuccess: (state, payload: { plan: BillingPlan }) =>
        adapter.update(state, { activePlan: payload.plan }),
      fetchActivePlanFailed: (state, payload: { error: HttpErrorResponse }) =>
        adapter.setError(state, payload.error),
    }),
  },
);

const BillingPlansSelectors = {
  ...selectors,
  billingPlans: createSelector(selectors.data, state => (state ? state?.billingPlans : null)),
  activePlan: createSelector(selectors.data, state => state?.activePlan),
};

export {
  actions as BillingPlansActions,
  BillingPlansSelectors,
  namespace as BillingPlansNamespace,
  reducer as BillingPlansReducer,
};
